import React from 'react';
import { ShieldWarning } from '@phosphor-icons/react';

const InactivityWarning = ({ onStay, onLogout }) => (
  <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/70 backdrop-blur-sm">
    <div className="bg-[#141414] border border-[#FF6B00] p-8 max-w-sm w-full mx-4 text-center shadow-2xl">
      <ShieldWarning size={48} weight="fill" className="text-[#FF6B00] mx-auto mb-4" />
      <h2 className="text-xl font-bold uppercase tracking-wider text-white mb-2">
        Sesión por expirar
      </h2>
      <p className="text-[#A3A3A3] text-sm mb-6">
        Por seguridad, tu sesión se cerrará en <span className="text-white font-bold">1 minuto</span> por inactividad.
      </p>
      <div className="flex gap-3">
        <button
          onClick={onStay}
          className="flex-1 bg-[#C2410C] hover:bg-[#9A3412] text-white font-bold uppercase tracking-wider py-3 text-sm transition-colors"
        >
          Seguir conectado
        </button>
        <button
          onClick={onLogout}
          className="flex-1 bg-[#1a1a1a] hover:bg-[#222] border border-[#333] text-[#A3A3A3] hover:text-white font-bold uppercase tracking-wider py-3 text-sm transition-colors"
        >
          Cerrar sesión
        </button>
      </div>
    </div>
  </div>
);

export default InactivityWarning;
